export default function useMapsApi() {
  if (typeof window !== "undefined" && window?.google?.maps) {
    return window.google.maps;
  }
}

// wip: make afterinteractive
// export default function useMapsApi() {
//   const [mapsApi, setMapsApi] = useState(null);

//   const handleMapsApiLoad = useCallback(() => {
//     setMapsApi(window?.google?.maps);
//   }, [setMapsApi]);

//   useEffect(() => {
//     // Fetch existing script element by src
//     // It may have been added by another intance of this hook
//     let script = document.querySelector(`script[src="${mapsApiSrc}"]`);

//     // Add event listeners
//     script.addEventListener("load", handleMapsApiLoad);
//     script.addEventListener("error", handleMapsApiLoad);
//   }, []);

//   return mapsApi;
// }
